import { h } from 'preact';
import { useContext } from 'preact/hooks';
import { IconContext } from '../../../common/components/svg/icons/icon-context';
import { withBreakPoints } from '../../hoc';
import { SECONDARY_FILL_COLOR, VIEWER_FILL_COLOR } from '../../theme/colors';
import { formatNumberOfViewer } from '../../utils/number';
import { Label } from '../common';

/* Get svg size according to the screen and orientation */

function ViewerLiveInfo({ connected, size }) {
  const Icon = useContext(IconContext);

  return (
    <Label
      message={`${formatNumberOfViewer(connected)} spectateurs`}
      style={{ backgroundColor: VIEWER_FILL_COLOR }}
      styleText={{ color: SECONDARY_FILL_COLOR }}
      icon={(
        <Icon
          name="eye-live"
          height={size}
          width={size}
          color={SECONDARY_FILL_COLOR}
          ariaHidden
        />
      )}
    />
  );
}

export default withBreakPoints(ViewerLiveInfo);
